export const NATIONAL_TEAMS = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "American-Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antigua",
  "Antigua and Barbuda",
  "Antigua-and-Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bonaire",
  "Bosnia",
  "Bosnia and Herzegovina",
  "Bosnia-Herzegovina",
  "Bostwana",
  "Botswana",
  "Brazil",
  "British-Virgin-Islands",
  "Brunei",
  "Brunei-Darussalam",
  "Bulgaria",
  "Bulgary",
  "Burkina Faso",
  "Burkina-Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape-Verde",
  "Cape-Verde-Islands",
  "Caracas",
  "Catalonia",
  "Cayman Islands",
  "Cayman-Islands",
  "Central-African-Republic",
  "Chad",
  "Chile",
  "China",
  "Chinese Taipei",
  "Chinese-Taipei",
  "Colombia",
  "Comoros",
  "Congo",
  "Congo DR",
  "Congo-DR",
  "Cook-Islands",
  "Costa Rica",
  "Costa-Rica",
  "Côte d'Ivoire",
  "Crimea",
  "Croatia",
  "Cuba",
  "Curacao",
  "Cyprus",
  "Czech Republic",
  "Czech-Republic",
  "Czechia",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican-Republic",
  "East-Timor",
  "Ecuador",
  "Egypt",
  "El-Salvador",
  "England",
  "Equatorial Guinea",
  "Equatorial-Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Eurocups",
  "Faroe Islands",
  "Faroe-Islands",
  "Fiji",
  "Finland",
  "France",
  "French-Guiana",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Holland",
  "Honduras",
  "Hong Kong",
  "Hong Kong, China",
  "Hong-Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "intl",
  "Iran",
  "Iraq",
  "Ireland",
  "Irland",
  "Israel",
  "Italia",
  "Italy",
  "Ivory Coast",
  "Ivory-Coast",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Korea",
  "Korea DPR",
  "Korea Republic",
  "Korea-DPR",
  "Korea-Republic",
  "Kosovo",
  "Kuwait",
  "Kyrgyz Republic",
  "Kyrgyz-Republic",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Lituania",
  "Luxembourg",
  "Lybia",
  "Macao",
  "Macau",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nepal",
  "Netherlands",
  "Netherlands-Antilles",
  "New Caledonia",
  "New Zealand",
  "New-Caledonia",
  "New-Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "North-Korea",
  "North-Macedonia",
  "Northern Ireland",
  "Northern-Ireland",
  "Northern-Mariana-Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Papua-New-Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Puerto-Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Martin",
  "Saint-Kitts-and-Nevis",
  "Saint-Lucia",
  "Saint-Martin",
  "Saint-Vincent-and-the-Grenadin",
  "Samoa",
  "San-Marino",
  "Sao-Tome-e-Principe",
  "Saudi Arabia",
  "Saudi-Arabia",
  "Scotland",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Sierra-Leone",
  "Singapore",
  "Sint-Maarten",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Solomon-Islands",
  "Somalia",
  "South Africa",
  "South-Africa",
  "South-Korea",
  "South-Sudan",
  "Spain",
  "Sri Lanka",
  "Sri-Lanka",
  "St. Kitts and Nevis",
  "St. Lucia",
  "Sudan",
  "Suriname",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Tahiti",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad-And-Tobago",
  "Tunisia",
  "Turkey",
  "Turkiye",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Turks-and-Caico-Islands",
  "Turks-and-Caicos-Islands",
  "UAE",
  "Uganda",
  "Ukraine",
  "United-Arab-Emirates",
  "Uruguay",
  "US-Virgin-Islands",
  "USA",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Wales",
  "World",
  "WorldCup",
  "Yemen",
  "Zambia",
  "Zanzibar",
  "Zimbabwe",
];
